export const URL_CLASH_ERROR_CODE = '201';

export const errorCodeList = [URL_CLASH_ERROR_CODE] as const;

export type ApiErrorCode = (typeof errorCodeList)[number];
